import React from 'react';
import { Text, Theme, CardBlock } from '@simplybenefits/sb-ui-library';
import Avatar from 'react-avatar';
import * as dates from "@simplybenefits/sb-dates";

/**
 * 
 * @param status
 * @returns color 
 */
const _setStatusColor = (status) => {
    const { brandGreen, red, skyBlue, darkGrey } = Theme.colors;

    switch (status) {
        case 'Completed':
            return brandGreen;
        case 'Cancelled':
            return red;
        case 'In Renewal':
            return skyBlue;
        case 'Pending':
            return darkGrey;
        default:
            return darkGrey;
    }
};

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const RenewalCard = ({ renewal, titleKey, onClick }) => {
    const styles = {
        upperCard: {
            borderBottom: `1px solid ${ Theme.colors.lightGrey }`,
            display: 'flex',
            justifyContent: 'space-between',
            height: '100%',
            width: '100%',
            paddingBottom: 11
        },
        upperLeftCard: {
            display: 'flex',
            height: '100%',
            lineHeight: '30px',
            alignItems: 'center'
        },
        upperRightCard: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            lineHeight: '30px'
        },
        lowerCard: {
            display: 'flex',
            height: 'auto',
            minHeight: 20,
            paddingTop: 9,
            paddingBottom: 12,
            width: '100%',
            justifyContent: 'space-between'
        }
    };

    return (
        <CardBlock onClick={ onClick }>
            <div style={ styles.upperCard }>
                <div style={ styles.upperLeftCard}>
                    <Avatar
                        name={`R ${ titleKey }`}
                        size="50"
                        textSizeRatio={2.2}
                        round={true}
                        fgColor={Theme.colors.skyBlue}
                        color={Theme.colors.lightBlue}
                        style={{ marginRight: 20 }}
                    />
                 
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Text large >
                            Renewal - { dates.formatDateForDisplay(renewal.renewalDate, 'll') }
                        </Text>

                        <Text
                            medium
                            display="inline"
                        >
                            { renewal.uid }
                        </Text>
                    </div>
                </div>
                <div style={ styles.upperRightCard }>
                    <Text
                        color={ _setStatusColor(renewal.status) }
                        align="right"
                        mediumLarge
                    >
                        { renewal.status }
                    </Text>

                    <Text
                        align="right"
                        small
                    >
                        Renewal Date: { dates.formatDateForDisplay(renewal.renewalDate, 'll') }
                    </Text>
                </div>
            </div>

            <div style={ styles.lowerCard }>
                <Text tiny >
                    Experience Period Start: { dates.formatDateForDisplay(renewal.periodStart, 'll') }
                </Text>

                <Text tiny >
                    Experience Period End: { dates.formatDateForDisplay(renewal.periodEnd, 'll') }
                </Text>

                <Text tiny >
                    Date Created: { dates.formatDateForDisplay(renewal.dateAdded, 'll') }
                </Text>

                <Text tiny >
                    Renewal Pickup Date: { dates.formatDateForDisplay(renewal.renewalPickupDate, 'll') }
                </Text>
            </div>
        </CardBlock>
    );
};

export default RenewalCard;